import React from 'react'

const PermissionCheckbox = ({ value, onChange }) => {
  const update = (key, checked) => {
    let updated = { ...value };

    if (key === 'canRead' && !checked) {
      updated = {
        canRead: false,
        canWrite: false,
        canDelete: false,
        canPrint: false
      };
    } else {
      updated[key] = checked;
      if (checked && key !== 'canRead') {
        updated.canRead = true;
      }
    }

    onChange(updated);
  };

  return (
    <div className="permission-checkbox-group">
      {['canRead', 'canWrite', 'canDelete', 'canPrint'].map(key => (
        <label key={key} style={{ marginRight: 10 }}>
          <input
            type="checkbox"
            checked={!!value[key]}
            disabled={key !== 'canRead' && !value.canRead}
            onChange={e => update(key, e.target.checked)}
          />
          {key.replace('can', '')[0]}
        </label>
      ))}
    </div>
  );
}

export default PermissionCheckbox;